import { faPencil, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Swal from "sweetalert2";
// import './ManageLeaveTypes.css'; // Import your CSS styles

const ManageLeaveTypes = ({
  leaveTypes,
  addPage,
  deletePage,
  pageSave,
  links,
}) => {
  const [delId, setDelId] = useState(0);
  const [modalData, setModalData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleDelete = (id) => {
    setDelId(id);
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Perform the delete action here
        console.log(`Deleting record with ID: ${id}`);
        // After deletion, you might want to refresh the list or update the state
      } else {
        Swal.fire("Cancelled", "Your record is safe :)", "error");
      }
    });
  };

  const handleModalOpen = (data) => {
    setModalData(data);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setModalData(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Perform save action here
    console.log(modalData);
    // You can use an API call to save the data
    Swal.fire("Success", "Leave type updated successfully!", "success").then(
      () => {
        handleModalClose(); // Close the modal after submission
      }
    );
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0">
            <h4 className="panel-title pull-left">Manage Leave Type</h4>
            {addPage && (
              <button
                className="btn btn-default btn-sm pull-right"
                onClick={() => (window.location.href = addPage)}
              >
                <FontAwesomeIcon icon={faPlus} />
                Add Leave Type
              </button>
            )}
          </div>
          {leaveTypes && leaveTypes.length > 0 ? (
            <div className="table-responsive">
              <table className="table m-b-0">
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>#</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Yearly Leave</th>
                    <th>Monthly Leave</th>
                    <th>Is Loss Of Pay</th>
                    <th style={{ width: "1%" }} colSpan="2">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {leaveTypes.map((leave, index) => (
                    <tr key={leave.id}>
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {index + 1}
                      </td>
                      <td>{leave.type}</td>
                      <td>{leave.description}</td>
                      <td>{leave.yearly_leave}</td>
                      <td>{leave.monthly_leave}</td>
                      <td>{leave.is_loss_of_pay === 1 ? "Yes" : "No"}</td>
                      <td>
                        <button
                          className="btn btn-warning btn-xs"
                          onClick={() => handleModalOpen(leave)}
                        >
                          <FontAwesomeIcon icon={faPencil} />
                        </button>
                      </td>
                      <td>
                        <button
                          className="cancel btn btn-danger btn-xs"
                          onClick={() => handleDelete(leave.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div>No records found.</div>
          )}
          {links && <div>{links}</div>}
        </div>
        {showModal && (
          <div className="modal" id="leaveModal">
            <div className="modal-dialog modal-sm">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Edit Leave Type</h4>
                  <button
                    type="button"
                    className="close"
                    onClick={handleModalClose}
                  >
                    &times;
                  </button>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="modal-body">
                    <div className="form-group">
                      <label>Type</label>
                      <input
                        type="text"
                        className="form-control"
                        value={modalData?.type || ""}
                        onChange={(e) =>
                          setModalData({ ...modalData, type: e.target.value })
                        }
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Description</label>
                      <input
                        type="text"
                        className="form-control"
                        value={modalData?.description || ""}
                        onChange={(e) =>
                          setModalData({
                            ...modalData,
                            description: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Yearly Leave</label>
                      <input
                        type="number"
                        className="form-control"
                        value={modalData?.yearly_leave || ""}
                        onChange={(e) =>
                          setModalData({
                            ...modalData,
                            yearly_leave: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Monthly Leave</label>
                      <input
                        type="number"
                        className="form-control"
                        value={modalData?.monthly_leave || ""}
                        onChange={(e) =>
                          setModalData({
                            ...modalData,
                            monthly_leave: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Is Loss Of Pay</label>
                      <select
                        className="form-control"
                        value={modalData?.is_loss_of_pay || ""}
                        onChange={(e) =>
                          setModalData({
                            ...modalData,
                            is_loss_of_pay: e.target.value,
                          })
                        }
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default ManageLeaveTypes;
